import { lazy } from "react";
import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/config/seoHead";

const BlackFriday = lazy(() => import("@/pages/elavtal/BlackFriday"));

export const Route = createFileRoute("/elavtal/black-friday")({
  head: () => seoHead("/elavtal/black-friday", { description: "Black Friday är perfekt för att byta elavtal – många elbolag släpper sina lägsta påslag och bästa kampanjer just under november." }),
  component: () => <BlackFriday />,
});
